import React from 'react';
import * as Styles from './DomainNotRegistered.styles';
import {
  IconCart, IconArrow, Button,
  IconExternalLink,
} from 'gatorcomponents';
import { NavigatorInput } from '../NavigatorInput';

const DomainNotRegistered = ({
  locale, backButton, goToPurchase, newDomain, mySiteLabel,
}) => {
  const handleBackButton = () => {
    backButton && backButton();
  };

  const handleGoToPurchase = () => {
    goToPurchase && goToPurchase();
  };
  return (
    <Styles.Wrapper>
      <Styles.HeadWrapper>
        <Styles.IconCircle>
          <IconCart color="primaryExtraDark" />
        </Styles.IconCircle>
        <Styles.Wrapper>
          <Styles.Title>
            {locale.title}
          </Styles.Title>
          <Styles.Description>
            {locale.description}
          </Styles.Description>

        </Styles.Wrapper>
      </Styles.HeadWrapper>
      <NavigatorInput newDomain={newDomain} mySiteLabel={mySiteLabel} />
      <Styles.ButtonsWrapper>
        <Button
          label={locale.backButton}
          variant="tertiary"
          width="fit"
          size="medium2"
          iconLeft={<IconArrow />}
          onClick={handleBackButton}
          testId="back-button"
        />

        <Button
          label={locale.continueButton}
          variant="primary"
          width="fit"
          size="medium2"
          iconRight={<IconExternalLink color="highPure" secondaryColor="transparent" />}
          notFillSVG
          onClick={handleGoToPurchase}
          testId="go-to-purchase-button"
        />
      </Styles.ButtonsWrapper>
    </Styles.Wrapper>
  );
};

export default DomainNotRegistered;
